module.exports = __webpack_public_path__ + "img/10.55e8c192.svg";